module.exports = __webpack_public_path__ + "static/media/BizTech5.0bcf653e.jpg";